import React from "react";
import { StpDetailsTable } from "../stp-details-table/StpDetailsTable";
import { StpDetails } from "../../graphql/graphql";
import type { TableRef } from "../base-table";

export const StpDetailsModalContent = ({
  tableRef,
  stpDetailsArray,
}: {
  tableRef: React.Ref<TableRef>;
  stpDetailsArray: StpDetails[] | [];
}) => (
  <div>
    <StpDetailsTable
      tableRef={tableRef}
      data={stpDetailsArray || []}
    />
  </div>
);